import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, _formatDate, CustomModal } from "../utils/commonImports";
import { Button, Alert, DatePicker } from "antd";
import { Icon } from "@iconify/react";
import { _api } from '../auth/Api';
import dayjs from "dayjs";
import { _exportToExcel } from "../helper/ExportToExcel";
import Select from "react-select";
import { customStyleMd } from "../utils/common";

const Inquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [viewModal, setViewModal] = useState({ isOpen: false, data: null });
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  const [vehiclesDrp, setVehiclesDrp] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    contactNo: "",
    vehicleName: "",
    createDateFrom: null,
    createDateTo: null,
  });

  useEffect(() => {
    _getInquiries();
    _getVehiclesDpr()
  }, []);

  const _getVehiclesDpr = async () => {
    try {
      await _api("GET", "Vehicle/GetDistinctVehicles", null, (res) => {
        if (res.isSuccess) {
          const List = res.data.map((v) => ({
            value: v.id,
            label: v.itemName,
          }));
          setVehiclesDrp(List);
        }
      });
    } catch (error) {
      console.log("API Error", error?.message);
    }
  };

  const _getInquiries = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      name: filterValues.name || "",
      email: filterValues.email || "",
      contactNo: filterValues.contactNo || "",
      vehicleName: filterValues.vehicleName || "",
      createDateFrom: filterValues.createDateFrom ? dayjs(filterValues.createDateFrom).format("YYYY-MM-DD") : "",
      createDateTo: filterValues.createDateTo ? dayjs(filterValues.createDateTo).format("YYYY-MM-DD") : "",
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords
      }
    };

    try {
      setLoading(true);
      await _api("POST", "Inquiry/GetAllInquiries", payload, (res) => {
        if (res.isSuccess) {
          setInquiries(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setInquiries([]);
          // Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setInquiries([]);
      setLoading(false);
      Toast.fire({ icon: "error", title: "Failed to fetch inquiries" });
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getInquiries(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    let filter = { name: "", email: "", contactNo: "", vehicleName: "", createDateFrom: null, createDateTo: null, }
    setShowExp(false)
    setFilters(filter);
    setPage(1);
    _getInquiries(filter, 1, pageSize);
  };

  const handleApply = () => {
    const { name, email, contactNo, vehicleName, createDateFrom, createDateTo } = filters;
    if (!name && !email && !contactNo && !vehicleName && !createDateFrom && !createDateTo) {
      setShowExp(true);
      return;
    }
    _getInquiries(filters, 1, pageSize);
  };

  const launchDetailModal = (type, record) => {
    setViewModal({ isOpen: type, data: record });
  };

  const columns = [
    {
      title: "Customer", dataIndex: "name",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          <Avatar src={null}>{record.name?.charAt(0).toUpperCase()}</Avatar>
          <div>{record.name}</div>
        </div>
      ),
    },
    {
      title: "Contact Info", dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.contactNo}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    { title: "Vehicle", dataIndex: "vehicleName" },
    { title: "Inquiry Date", dataIndex: "createDate", render: (date) => _formatDate(date) },
    {
      title: "Status", dataIndex: "status",
      render: (status) => (
        <span className={`badge ${status === 'Active' ? 'bg-success' :
          status === 'warm' ? 'bg-warning' : 'bg-secondary'
          }`}>
          {status}
        </span>
      ),
    },
    {
      title: "Details",
      render: (_, record) =>
        <Button
          icon={<Icon icon="feather:eye" />}
          onClick={() => launchDetailModal(true, record)}
        />
    },
  ];

  const xlsColumns = [
    { title: "User Id", dataIndex: "userId" },
    { title: "Customer Name", dataIndex: "name" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "contactNo" },
    { title: "Vehicle", dataIndex: "vehicleName" },
    { title: "Description", dataIndex: "description" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      name: "",
      email: "",
      contactNo: "",
      vehicleName: "",
      createDate: null,
      page: {
        pageNo: 0,
        numberOfRecords: 0
      }
    };

    try {
      await _api("POST", "Inquiry/GetAllInquiries", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            createDate: _formatDate(x.createDate),
          }));

          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Customer Inquiries",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Inquiries & Leads" />
      {filterBtnShow && (
        <Card className="mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  value={filters.name}
                  onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) => setFilters({ ...filters, email: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact No"
                  value={filters.contactNo}
                  onChange={(e) => setFilters({ ...filters, contactNo: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <Select
                  // options={vehicleOptions}
                  options={[
                    { label: "Alsvin", value: "alsvin" },
                    { label: "Karvaan", value: "karvaan" },
                    { label: "Oshan", value: "oshan" },
                    { label: "Sherpa", value: "sherpa" }
                  ]}
                  value={vehiclesDrp.find(opt => opt.label === filters.vehicleName) || null}
                  onChange={(val) => setFilters({ ...filters, vehicleName: val?.label || "" })}
                  placeholder="Vehicle Name"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateFrom ? dayjs(filters.createDateFrom) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateFrom: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // aaj ke baad wali date disable
                    if (current && current > dayjs().endOf("day")) return true;

                    // agar To Date select h to us se baad wali disable
                    if (filters.createDateTo) {
                      return current && current > dayjs(filters.createDateTo);
                    }
                    return false;
                  }}
                  placeholder="From Date"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateTo ? dayjs(filters.createDateTo) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateTo: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateFrom) {
                      return current && current < dayjs(filters.createDateFrom);
                    }
                    return false;
                  }}
                  placeholder="To Date"
                />
              </div>

            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-sm btn-outline-secondary" onClick={() => setFilterBtnShow(false)}>
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}
      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Inquiries
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>

          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={inquiries}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "inquiryId",
            emptyText: "No inquiries found",
            pageKey: 14
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: inquiries.length
          }}
          onChange={handleTableChange}
        />
      </Card>

      <CustomModal
        title="View Inquiry"
        show={viewModal.isOpen}
        size="lg"
        onHide={() => setViewModal(false, {})}
      >
        {viewModal.data && (
          <div className="row g-3">
            <div className="col-md-2">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Inquiry ID:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.inquiryId}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Name:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.name}</div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Email:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.email}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Contact No:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.contactNo}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Vehicle Name:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.vehicleName}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Status:</small>
                <div>
                  <span className={`badge ${viewModal.data?.status === "warm" ? "bg-warning " : "bg-secondary"}`}>
                    {viewModal.data?.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Description:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.description}</div>
              </div>
            </div>

            <div className="col-md-6 d-none">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Created On:</small>
                <div className="fw-semibold text-sm">
                  {viewModal.data?.createDate?.slice(0, 10)}
                </div>
              </div>
            </div>

            <div className="col-md-6 d-none">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Created By (User ID):</small>
                <div className="fw-semibold text-sm">{viewModal.data?.isCreatedBy}</div>
              </div>
            </div>
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default Inquiries;